export enum CBTProgramWeekFiveStep {
    HowDidMindfulnessOfEmotionsGoStep = 'how-did-mindfulness-of-emotions-go-last-week',
    WhyFocusOnThoughtsStep = 'why-focus-on-thoughts',
    ThoughtsMatterStep = 'thoughts-matter',
    YourExperienceOfThoughtsStep = 'your-experience-of-thoughts',
    ThoughtsCanBeUnhelpfulStep = 'thoughts-can-be-unhelpful',
    DevelopingCognitiveFlexibilityStep = 'developing-cognitive-flexibility',
    LookingAtAlternativesStep = 'looking-at-alternatives',
    ChallengeTheThoughtStep = 'challenge-the-thought',
    IdentifyAnAlternativeThoughtStep = 'identify-an-alternative-thought',
}

export enum CBTProgramWeekFiveSurvey {
    HowDidMindfulnessOfEmotionsGo = 'week-5-how-did-mindfulness-of-emotions-go',
    YourExperienceOfThoughts = 'week-5-your-experience-of-thoughts',
    LookingAtAlternatives = 'week-5-looking-at-alternatives',
    IdentifyAnAlternativeThought = 'week-5-identify-an-alternative-thought',
}
